import { create, tsx } from '@dojo/framework/core/vdom';
import { Link } from '@dojo/framework/routing/Link';
import { Head } from './Head';
import { jobs, Section as JobSection } from '../pages/careers/jobs';

import * as css from './JobPost.m.css';
import LinkButton from './LinkButton';
import ContentWrapper from './ContentWrapper';
import Section from './Section';
import Page from './Page';
import HeroBackground from './HeroBackground';
import Text from './Text';

export interface JobPostProperties {
	id: string;
}

function content(section: JobSection, isSubsection = false) {
	return (
		<virtual>
			{section.text &&
				(Array.isArray(section.text) ? (
					section.text.map((text) => <p>{text}</p>)
				) : (
					<p>{section.text}</p>
				))}
			{section.points && (
				<ul classes={css.list}>
					{section.points.map((point) => (
						<li>{point}</li>
					))}
				</ul>
			)}
			{!isSubsection &&
				section.subsections &&
				section.subsections.map((subsection) => {
					if (subsection.title) {
						return (
							<div classes={css.subsection}>
								<h4 classes={css.h4}>{subsection.title}</h4>
								{content(subsection, true)}
							</div>
						);
					} else {
						return content(subsection, true);
					}
				})}
		</virtual>
	);
}
const factory = create().properties<JobPostProperties>();

export const JobPost = factory(function JobPost({ properties }) {
	const { id } = properties();
	const job = jobs.find((job) => job.route === id);

	if (!job) {
		return;
	}

	const { name, title, description, type, sections } = job;
	const mailtoUrl = `mailto:careers@sitepen.com?subject=Job Application: ${name}`;

	return (
		<Page>
			{{
				head: <Head title={title} description={description} />,
				hero: {
					background: <HeroBackground background="level2PurpleTeal" />,
					content: (
						<ContentWrapper>
							<div classes={[css.hero]}>
								<Text type="hero-subhead">{`${type} | Remote`}</Text>
								<div classes={[css.titleWrapper]}>
									<Text type="hero-primary" responsive="callout-head">
										{name}
									</Text>
								</div>
							</div>
						</ContentWrapper>
					)
				},
				page: (
					<Section type="leading">
						<ContentWrapper size="smaller">
							<p>
								<Link to="careers">‹ Back to Careers</Link>
							</p>
							{sections.map((section) => {
								if (section.title) {
									return (
										<section classes={css.section}>
											<h3 classes={css.h3}>{section.title}</h3>
											{content(section)}
										</section>
									);
								} else {
									return (
										<section classes={css.section}>{content(section)}</section>
									);
								}
							})}

							<section classes={css.section}>
								<LinkButton href={mailtoUrl}>Apply Now</LinkButton>
							</section>
						</ContentWrapper>
					</Section>
				)
			}}
		</Page>
	);
});

export default JobPost;
